import { t } from "../../i18n";
import { SeoMetadataEditor } from "../seo/SeoMetadataEditor";
import { CasinoPageSeoDraft } from "./casinoPageSeoDraft";
import { tabFallbackInputs } from "./casinoSeoFallbackInputs";
import { casinoSeoDisplayUrl } from "./casinoSeoUrl";
import { SeoDraftEditorShell } from "./SeoDraftEditorShell";

export interface CasinoTabSeoEditorProps {
  draft: CasinoPageSeoDraft;
  /** The tab's id, or its client key while it is unsaved. */
  tabKey?: string;
  /** Undefined while the tab is unsaved. */
  tabId?: number;
  /** Undefined until the page has been saved once. */
  casinoPageId?: number;
  pageName?: string;
  defaultPage?: boolean;
  tabName?: string;
}

/** One tab's SEO editor. It loads the page's SEO into the draft every tab editor shares, and edits this tab's part. */
export function CasinoTabSeoEditor({ draft, tabKey, tabId, casinoPageId, pageName, defaultPage, tabName }: CasinoTabSeoEditorProps): JSX.Element | null {
  if (tabKey === undefined) {
    return null;
  }
  return (
    <div data-testid={`seo-tab-${tabKey}-section`}>
      <h4>{t("admin.seo.heading", undefined, "SEO")}</h4>
      <SeoDraftEditorShell
        draft={draft}
        targetId={casinoPageId}
        saveFirstMessage={t("admin.seo.save-page-first-tab", undefined, "Save the page once to edit this tab's SEO.")}
        saveFirstTestId="seo-tab-save-first"
        testIdPrefix={`seo-tab-${tabKey}`}
        renderFields={(context) => (
          <SeoMetadataEditor
            locales={context.locales ?? []}
            values={draft.getTabValues(tabKey)}
            fallbackInputs={tabFallbackInputs(context, tabKey)}
            cmsAvailable={context.cmsAvailable ?? false}
            displayUrl={casinoSeoDisplayUrl({ pageId: casinoPageId, pageName, defaultPage, tabId, tabName })}
            onChange={(locale, field, value) => draft.setTabField(tabKey, locale, field, value)}
            testIdPrefix={`seo-tab-${tabKey}`}
          />
        )}
      />
    </div>
  );
}
